export const frontmatter = {
    "draft": false,
    "title": "Guide: Chatbots",
    "description": "How to create and configure conversational chatbots in OnnIA. Chatbot types: Simple agent, Router, Sequential, and Parallel.",
    "sidebar_label": "Chatbots",
    "sidebar_group": "reference",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "accessing-the-module",
        "value": "Accessing the module"
    },
    {
        "depth": 2,
        "id": "chatbot-types",
        "value": "Chatbot types"
    },
    {
        "depth": 2,
        "id": "simple-agent-single-agent",
        "value": "Simple agent (Single-agent)"
    },
    {
        "depth": 2,
        "id": "intelligent-routing-router",
        "value": "Intelligent routing (Router)"
    },
    {
        "depth": 2,
        "id": "step-by-step-sequential",
        "value": "Step by step (Sequential)"
    },
    {
        "depth": 2,
        "id": "expert-team-parallel",
        "value": "Expert team (Parallel)"
    },
    {
        "depth": 2,
        "id": "widget-configuration",
        "value": "Widget configuration"
    }
]